import React from "react";
import { Phase } from "helpers/app";
import { Routing } from "helpers/routing";
import { useParams } from "react-router-dom";
import { SportsmanDatasourceIdentifierContext } from "./SportmsanDatasourceIdentifiers.context";
import Detail from "./_Detail";
import Select from "./_Select";

const SportsmanDatasourceIdentifier: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.SportsmanDatasourceIdentifierParams>()

  return (
    <SportsmanDatasourceIdentifierContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </SportsmanDatasourceIdentifierContext.Provider>
  )
}

export default SportsmanDatasourceIdentifier
